import React from 'react'
import {
    hideHandler,
    filterMoneyHandler,
    objectLang,
    parseNameWithDate,
    sortDate,
    getMoneyPathBack,
    getGlobalMoneyObject,
    expandCollapseHandler,
} from "../functions"
import {Link} from "react-router-dom"
import {CalendarClass} from "./CalendarClass"
import {MoneyNav} from "../elements/MoneyNav"

export class MonthDetailClass extends React.Component {

    render() {

        const {
            dataMonthGlobal,
            updateHandler,
            expandIncome,
            setExpandIncome,
            expandExpense,
            setExpandExpense,
            deleteHandler,
            setPreTotalInc,
            preTotalInc,
            setPreTotalExp,
            preTotalExp,
            calculation
        } = this.props

        const lang = objectLang().language
        const l = lang.lang

        let currency = dataMonthGlobal['currency'],
            nameMonth = `${lang.body.moneyPage[dataMonthGlobal['nameMonth']]}`

        const arrIncomesCategories = [],
            arrExpensesCategories = [],
            arrIncomesCategoriesAll = [],
            arrExpensesCategoriesAll = []

        let incomes = dataMonthGlobal['incomesOfNamesTotalsPurchase'],
            expenses = dataMonthGlobal['expensesOfNamesTotalsPurchase'],
            incomesAll = dataMonthGlobal['incomesAllFieldsPurchase'],
            expensesAll = dataMonthGlobal['expensesAllFieldsPurchase'],
            balanceMonth = dataMonthGlobal['balanceMonthPurchase'],
            expensesMonthTotal = dataMonthGlobal['expensesMonthTotalPurchase'],
            incomesMonthTotal = dataMonthGlobal['incomesMonthTotalPurchase']

        if (calculation === 'payment_date') {
            incomes = dataMonthGlobal['incomesOfNamesTotalsPayment']
            expenses = dataMonthGlobal['expensesOfNamesTotalsPayment']
            incomesAll = dataMonthGlobal['incomesAllFieldsPayment']
            expensesAll = dataMonthGlobal['expensesAllFieldsPayment']
            balanceMonth = dataMonthGlobal['balanceMonthPayment']
            expensesMonthTotal = dataMonthGlobal['expensesMonthTotalPayment']
            incomesMonthTotal = dataMonthGlobal['incomesMonthTotalPayment']
        }

        for (const name in incomes) {
            const value = incomes[name]
            arrIncomesCategories.push([name, value])
        }

        for (const name in expenses) {
            const value = expenses[name]
            arrExpensesCategories.push([name, value])
        }

        for (const name in incomesAll) {
            const value = incomesAll[name]
            if (parseNameWithDate(name).date && parseNameWithDate(name).name && parseNameWithDate(name).means) {
                arrIncomesCategoriesAll.push([parseNameWithDate(name).date, parseNameWithDate(name).name, parseNameWithDate(name).means, value, name])
            }
        }

        for (const name in expensesAll) {
            const value = expensesAll[name]
            if (parseNameWithDate(name).date && parseNameWithDate(name).name && parseNameWithDate(name).means && parseNameWithDate(name).datePay) {
                arrExpensesCategoriesAll.push([parseNameWithDate(name).date, parseNameWithDate(name).name, parseNameWithDate(name).means, value, name, parseNameWithDate(name).datePay])
            }
        }

        arrExpensesCategoriesAll.sort((a, b) => {
            return sortDate(a, b, 0)
        })
        arrIncomesCategoriesAll.sort((a, b) => {
            return sortDate(a, b, 0)
        })

        arrExpensesCategories.reverse()
        arrIncomesCategories.reverse()

        const dataNav = {
            pathBack: `/${l}/money/year?year=${dataMonthGlobal['nameYear']}&calculation=purchase_date`,
            isMain: false,
            isMoney: true,
            isSetting: false,
            isAddIncome: true,
            isAddCredit: false,
            isAddPurchase: true,
            isYearDetail: true,
            isMonthDetail: true,
            isSelectPeriod: true,
            currency: getGlobalMoneyObject()['currency']
        }

        return (
            <>
                <MoneyNav  dataNav={dataNav}/>
                <div className={"mt-3 col col-sm-11 col-lg-12 col-xl-9 m-auto"}>
                    <div className={"card"}>
                        <div className={"card-body"}>
                            <div className={'col col-12 d-flex justify-content-between mb-3'}>
                                <div className={'col col-6 d-flex justify-content-end'}>
                                    <h5 className={"card-title m-auto fs-5"}>{`${nameMonth} ${dataMonthGlobal['nameYear']}`}</h5>
                                </div>
                                <div className={'col col-5 d-flex justify-content-end'}>
                                    <h5 className={"card-title m-auto pe-2"}>{lang.body.moneyPage.main.balance}&nbsp;{balanceMonth}</h5>
                                </div>
                                <Link to={getMoneyPathBack()}
                                      id={"button-close-month"}
                                      className={"col col-1 btn-close fs-3 m-0"}
                                      aria-label={"Close"}>
                                </Link>
                            </div>

                            <CalendarClass/>

                            <div className={`year-income-expense m-1`}>

                                {/* Месячные Доходы */}
                                <div className={'col border border-3 rounded-2 m-2 ps-2 pe-2 pt-3 pb-3'}>
                                    <div id={'div-incomes-month'} className={'col align-self-end'}>
                                        <div className={'filter row col w-50 d-flex flex-nowrap mb-2'}>
                                            <button className={'btn col col-1 ms-3'}
                                                    onClick={() => {
                                                        expandCollapseHandler('btn-income-expand-collapse', 'income', setExpandIncome, setExpandExpense)
                                                    }}>
                                                <i id={'btn-income-expand-collapse'}
                                                   className={"fa-solid fa-chevron-down fs-3 opacity-75 p-0"}/>
                                            </button>
                                            <h4 id={'add-income-month-name col col-10'}
                                                className={"d-flex align-items-end justify-content-center"}>{lang.body.moneyPage.main.incomes}</h4>
                                            {!expandIncome && <input
                                                autoComplete={"off"}
                                                id={'incomes-filter'}
                                                className={'form-control col col-1 w-75'}
                                                placeholder={lang.body.moneyPage.filterPlaceholder}
                                                onChange={(event) => {
                                                    const filterRes = filterMoneyHandler(event, arrIncomesCategoriesAll, 'month-all')
                                                    const resultArrNames = filterRes.names
                                                    setPreTotalInc(filterRes.preTotal)
                                                    hideHandler(resultArrNames, 'div-incomes-month', 'month-all')
                                                    if (preTotalInc > 0) {
                                                        document.querySelector('#pre-total-incomes').classList.remove('d-none')
                                                    } else {
                                                        document.querySelector('#pre-total-incomes').classList.add('d-none')
                                                    }
                                                }}/>}
                                            {expandIncome && <input
                                                autoComplete={"off"}
                                                id={'incomes-filter'}
                                                className={'form-control col col-1 w-75'}
                                                placeholder={lang.body.moneyPage.filterPlaceholder}
                                                onChange={(event) => {
                                                    const filterRes = filterMoneyHandler(event, arrIncomesCategories, 'month')
                                                    const resultArrNames = filterRes.names
                                                    setPreTotalInc(filterRes.preTotal)
                                                    hideHandler(resultArrNames, 'div-incomes-month', 'month')
                                                    if (preTotalInc > 0) {
                                                        document.querySelector('#pre-total-incomes').classList.remove('d-none')
                                                    } else {
                                                        document.querySelector('#pre-total-incomes').classList.add('d-none')
                                                    }
                                                }}/>}
                                        </div>

                                        {!expandIncome && arrIncomesCategories.map((category, index) => {
                                            const nameCat = category[0]
                                            const value = category[1].toFixed(2)
                                            if (nameCat !== 'total') {
                                                return (
                                                    <div id={`income-row-${index}`} className={'row m-1 mt-3'}
                                                         key={index}>
                                                        <div id={`income-div-${index}`}
                                                             className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                            <h6 id={`income-name-${index}`}
                                                                className={'m-0'}>{nameCat}</h6>
                                                            <p id={`income-value-${index}`}
                                                               className={'m-0'}>{`${value} (${currency})`}</p>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (<></>)
                                            }
                                        })}
                                        {expandIncome && arrIncomesCategoriesAll.map((category, index) => {
                                            const dateCat = category[0]
                                            const nameCat = category[1]
                                            const value = category[3].toFixed(2)
                                            const fullName = category[4]
                                            if (nameCat !== 'total') {
                                                return (
                                                    <div id={`income-row-${index}`}
                                                         className={'row m-1 mt-3'}
                                                         key={index}
                                                         onClick={() => {
                                                             updateHandler({
                                                                 nameRecordDB: fullName.split(';')[0],
                                                                 means: dataMonthGlobal['cards'],
                                                                 nameYear: dataMonthGlobal['nameYear'],
                                                                 nameMonth: dataMonthGlobal['nameMonth'],
                                                                 purpose: 'incomes',
                                                                 oldName: fullName,
                                                                 oldValue: value,
                                                                 row: `income-row-${index}`,
                                                                 div: `income-div-${index}`,
                                                                 divDate: `income-div-date-${index}`,
                                                                 datePay: `income-date-${index}-payment`,
                                                                 cardId: `income-cardId-${index}`,
                                                                 name: `income-name-${index}`,
                                                                 value: `income-value-${index}`,
                                                                 divIconUpdate: `income-div-icon-update-${index}`,
                                                                 iIconUpdate: `income-i-icon-update-${index}`,
                                                                 divIconRemove: `income-div-icon-remove-${index}`,
                                                                 iIconRemove: `income-i-icon-remove-${index}`
                                                             })
                                                         }}
                                                         onTouchCancel={() => {
                                                             updateHandler({
                                                                 nameRecordDB: fullName.split(';')[0],
                                                                 means: dataMonthGlobal['cards'],
                                                                 nameYear: dataMonthGlobal['nameYear'],
                                                                 nameMonth: dataMonthGlobal['nameMonth'],
                                                                 purpose: 'incomes',
                                                                 oldName: fullName,
                                                                 oldValue: value,
                                                                 row: `income-row-${index}`,
                                                                 div: `income-div-${index}`,
                                                                 divDate: `income-div-date-${index}`,
                                                                 datePay: `income-date-${index}-payment`,
                                                                 cardId: `income-cardId-${index}`,
                                                                 name: `income-name-${index}`,
                                                                 value: `income-value-${index}`,
                                                                 divIconUpdate: `income-div-icon-update-${index}`,
                                                                 iIconUpdate: `income-i-icon-update-${index}`,
                                                                 divIconRemove: `income-div-icon-remove-${index}`,
                                                                 iIconRemove: `income-i-icon-remove-${index}`
                                                             })
                                                         }}>
                                                        <div id={`income-div-date-${index}`}
                                                             className={'d-flex justify-content-start'}>
                                                            <i className={"mt-1 me-2 opacity-50 fa-solid fa-money-check-dollar"}/>
                                                            <p id={`income-date-${index}-payment`}
                                                               className={'m-0 opacity-50'}>{dateCat}</p>
                                                            <p id={`income-cardId-${index}`}
                                                               className={'m-0'}>{''}</p>
                                                        </div>
                                                        <div id={`income-div-${index}`}
                                                             className={'col col-11 d-flex justify-content-between border-bottom'}>
                                                            <h6 id={`income-name-${index}`}
                                                                className={'m-0'}>{nameCat}</h6>
                                                            <p id={`income-value-${index}`}
                                                               className={'m-0'}>{`${value} (${currency})`}</p>
                                                        </div>
                                                        <div id={`income-div-icon-update-${index}`}
                                                             className={'col col-1 d-flex justify-content-end border-bottom text-primary d-none'}>
                                                            <i id={`income-i-icon-update-${index}`}
                                                               className={"fa-solid fa-pen-to-square d-flex align-items-center"}
                                                            />
                                                        </div>
                                                        <div id={`income-div-icon-remove-${index}`}
                                                             className={'col col-1 d-flex justify-content-end border-bottom'}>
                                                            <i id={`income-i-icon-remove-${index}`}
                                                               className={"fa-solid fa-trash-can d-flex align-items-center text-danger"}
                                                               onClick={() => {
                                                                   deleteHandler({
                                                                       nameRecordDB: fullName.split(';')[0],
                                                                       purpose: 'incomes',
                                                                   })
                                                               }}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (<></>)
                                            }
                                        })}

                                    </div>

                                    <div id={'pre-total-incomes'} className={'filter row m-1 mt-5 d-none'}>
                                        <div className={'col col-12 d-flex justify-content-between border-bottom'}>
                                            <h6 className={'m-0 text-primary'}>{'Итого по фильтру'}</h6>
                                            <p className={'m-0'}>{`${preTotalInc} (${currency})`}</p>
                                        </div>
                                    </div>
                                    <div className={'filter row m-1 mt-4'}>
                                        <div className={'col col-12 d-flex justify-content-between border-bottom'}>
                                            <h6 className={'m-0 text-success'}>{'Всего доходов'}</h6>
                                            <p className={'m-0'}>{`${incomesMonthTotal} (${currency})`}</p>
                                        </div>
                                    </div>

                                </div>

                                {/* Месячные Расходы */}
                                <div className={'col border border-3 rounded-2 m-2 ps-2 pe-2 pt-3 pb-3'}>
                                    <div id={'div-expenses-month'} className={'add-expense ps-2 pe-2'}>
                                        <div className={'filter row col w-50 d-flex flex-nowrap mb-2'}>
                                            <button className={'btn col col-1 ms-3'}
                                                    onClick={() => {
                                                        expandCollapseHandler('btn-expense-expand-collapse', 'expense', setExpandIncome, setExpandExpense)
                                                    }}>
                                                <i id={'btn-expense-expand-collapse'}
                                                   className={"fa-solid fa-chevron-down fs-3 opacity-75 p-0"}/>
                                            </button>
                                            <h4 id={'add-expense-month-name col col-10'}
                                                className={"d-flex align-items-end justify-content-center"}>{lang.body.moneyPage.main.expenses}</h4>
                                            {!expandExpense && <input
                                                autoComplete={"off"}
                                                id={'expenses-filter'}
                                                className={'form-control col col-1 w-75'}
                                                placeholder={lang.body.moneyPage.filterPlaceholder}
                                                onChange={(event) => {
                                                    const filterRes = filterMoneyHandler(event, arrExpensesCategoriesAll, 'month-all')
                                                    const resultArrNames = filterRes.names
                                                    hideHandler(resultArrNames, 'div-expenses-month', 'month-all')
                                                    setPreTotalExp(filterRes.preTotal)
                                                    if (preTotalExp > 0) {
                                                        document.querySelector('#pre-total-expenses').classList.remove('d-none')
                                                    } else {
                                                        document.querySelector('#pre-total-expenses').classList.add('d-none')
                                                    }
                                                }}/>}
                                            {expandExpense && <input
                                                autoComplete={"off"}
                                                id={'expenses-filter'}
                                                className={'form-control col col-1 w-75'}
                                                placeholder={lang.body.moneyPage.filterPlaceholder}
                                                onChange={(event) => {
                                                    const filterRes = filterMoneyHandler(event, arrExpensesCategories, 'month')
                                                    const resultArrNames = filterRes.names
                                                    hideHandler(resultArrNames, 'div-expenses-month', 'month')
                                                    setPreTotalExp(filterRes.preTotal)
                                                    if (preTotalExp > 0) {
                                                        document.querySelector('#pre-total-expenses').classList.remove('d-none')
                                                    } else {
                                                        document.querySelector('#pre-total-expenses').classList.add('d-none')
                                                    }
                                                }}/>}
                                        </div>

                                        {!expandExpense && arrExpensesCategories.map((category, index) => {
                                            // const dateCat = category[0]
                                            const nameCat = category[0]
                                            const value = category[1].toFixed(2)
                                            if (nameCat !== 'total') {
                                                return (
                                                    <div id={`expense-row-${index}`} className={'row m-1 mt-3'}
                                                         key={index}>
                                                        <div id={`expense-div-${index}`}
                                                             className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                            <h6 id={`expense-name-${index}`}
                                                                className={'m-0'}>{nameCat}</h6>
                                                            <p id={`expense-value-${index}`}
                                                               className={'m-0'}>{`${value} (${currency})`}</p>
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (<></>)
                                            }
                                        })}
                                        {expandExpense && arrExpensesCategoriesAll.map((category, index) => {
                                            const datePur = category[0]
                                            const nameCat = category[1]
                                            const datePay = category[5]
                                            const value = category[3].toFixed(2)
                                            const fullName = category[4]
                                            if (nameCat !== 'total') {
                                                return (

                                                    <div id={`expense-row-${index}`} className={'row m-1 mt-3'}
                                                         key={index}
                                                         onClick={() => {
                                                             updateHandler({
                                                                 nameRecordDB: fullName.split(';')[0],
                                                                 means: dataMonthGlobal['cards'],
                                                                 nameYear: dataMonthGlobal['nameYear'],
                                                                 nameMonth: dataMonthGlobal['nameMonth'],
                                                                 purpose: 'expenses',
                                                                 oldName: fullName,
                                                                 oldValue: value,
                                                                 row: `expense-row-${index}`,
                                                                 div: `expense-div-${index}`,
                                                                 divDate: `expense-div-date-${index}`,
                                                                 datePur: `expense-date-${index}-purchase`,
                                                                 datePay: `income-date-${index}-payment`,
                                                                 cardId: `expense-cardId-${index}`,
                                                                 name: `expense-name-${index}`,
                                                                 value: `expense-value-${index}`,
                                                                 divIconUpdate: `expense-div-icon-update-${index}`,
                                                                 iIconUpdate: `expense-i-icon-update-${index}`,
                                                                 divIconRemove: `expense-div-icon-remove-${index}`,
                                                                 iIconRemove: `expense-i-icon-remove-${index}`,
                                                             })
                                                         }}
                                                         onTouchCancel={() => {
                                                             updateHandler({
                                                                 nameRecordDB: fullName.split(';')[0],
                                                                 means: dataMonthGlobal['cards'],
                                                                 nameYear: dataMonthGlobal['nameYear'],
                                                                 nameMonth: dataMonthGlobal['nameMonth'],
                                                                 purpose: 'expenses',
                                                                 oldName: fullName,
                                                                 oldValue: value,
                                                                 row: `expense-row-${index}`,
                                                                 div: `expense-div-${index}`,
                                                                 divDate: `expense-div-date-${index}`,
                                                                 datePur: `expense-date-${index}-purchase`,
                                                                 datePay: `income-date-${index}-payment`,
                                                                 cardId: `expense-cardId-${index}`,
                                                                 name: `expense-name-${index}`,
                                                                 value: `expense-value-${index}`,
                                                                 divIconUpdate: `expense-div-icon-update-${index}`,
                                                                 iIconUpdate: `expense-i-icon-update-${index}`,
                                                                 divIconRemove: `expense-div-icon-remove-${index}`,
                                                                 iIconRemove: `expense-i-icon-remove-${index}`,
                                                             })
                                                         }}>
                                                        <div id={`expense-div-date-${index}`}
                                                             className={'d-flex justify-content-start'}
                                                             style={{width: "100%"}}>
                                                            <i className={"mt-1 me-2 opacity-50 fa-solid fa-bag-shopping"}/>
                                                            <p id={`expense-date-${index}-purchase`}
                                                               className={'m-0 me-4 opacity-50'}>{`${datePur}`}</p>
                                                            <i className={"mt-1 me-2 opacity-50 fa-solid fa-money-check-dollar"}/>
                                                            <p id={`expense-date-${index}-payment`}
                                                               className={'m-0 mb-1 opacity-50'}>{`${datePay}`}</p>
                                                            <p id={`expense-cardId-${index}`}
                                                               className={'m-0'}>{''}</p>
                                                        </div>
                                                        <div id={`expense-div-${index}`}
                                                             className={'col col-11 d-flex justify-content-between border-3 border-bottom'}>
                                                            <h6 id={`expense-name-${index}`}
                                                                className={'m-0'}>{nameCat}</h6>
                                                            <p id={`expense-value-${index}`}
                                                               className={'m-0'}>{`${value} (${currency})`}</p>
                                                        </div>
                                                        <div id={`expense-div-icon-update-${index}`}
                                                             className={'col col-1 d-flex justify-content-end border-3 border-bottom d-none'}>
                                                            <i id={`expense-i-icon-update-${index}`}
                                                               className={"fa-solid fa-pen-to-square d-flex align-items-center text-primary"}
                                                            />
                                                        </div>
                                                        <div id={`expense-div-icon-remove-${index}`}
                                                             className={'col col-1 d-flex justify-content-end border-3 border-bottom'}>
                                                            <i id={`expense-i-icon-remove-${index}`}
                                                               className={"fa-solid fa-trash-can d-flex align-items-center text-danger"}
                                                               onClick={() => {
                                                                   deleteHandler({
                                                                       nameRecordDB: fullName.split(';')[0],
                                                                       purpose: 'expenses',
                                                                   })
                                                               }}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            } else {
                                                return (<></>)
                                            }
                                        })}
                                        <div id={'pre-total-expenses'} className={'filter row m-1 mt-5 d-none'}>
                                            <div className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                <h6 className={'m-0 text-primary'}>{'Итого по фильтру'}</h6>
                                                <p className={'m-0'}>{`${preTotalExp} (${currency})`}</p>
                                            </div>
                                        </div>
                                        <div className={'filter row m-1 mt-4'}>
                                            <div className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                <h6 className={'m-0 text-danger'}>{'Всего расходов'}</h6>
                                                <p className={'m-0'}>{`${expensesMonthTotal} (${currency})`}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
